import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';

import Constants, { appConfig } from '../../config.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js";

// .module.css prevents affecting other .js files
import "../../resources/css/select_wallet.module.css"
import { getLog } from '../../helpers/helpers.js';
import HoverSelector from '../../components/HoverSelector.js';
import { ButtonPrimaryOutlined } from '../../components/Buttons.js';


const invisibleLinkStyle = {
    textDecoration: "none",
    cursor: "pointer",
    color: "white",
}

const useStyles = makeStyles({
    invisibleLink: {
        ...invisibleLinkStyle,
        '&:hover': {
            ...invisibleLinkStyle,
        },
    },
});


export default function Select_Wallet(props) {
    const classname = "Select_Wallet: "
    const function_id = classname
    const log = getLog(function_id)

    const classes = useStyles();
    const history = useHistory();

    // import { useTheme } from '@mui/material';
    // const theme = useTheme(); // Access the theme directly
    // const primaryColor = theme.palette.primary.main

    const userContext = useContext(UserContext)

    // Info about a wallet saved on this device (localStorage remembered blob).
    const [rememberedInfo, setRememberedInfo] = useState(null)

    async function onMountedComponent() {
        // Only clear the pending_wallet staging area (leftover from a
        // previous create/restore flow that was abandoned mid-way).
        // We do NOT call reset_wallet() here — that would destroy the
        // currently loaded mock wallet, causing a broken state when the
        // user clicks "Back" (re-init race, 16-second update_run, etc).
        // The mock wallet stays in memory; clicking "Back" returns to
        // /wallet with the mock wallet still loaded.
        await userContext.clear_pending_wallet()
        // Read the remembered wallet info from localStorage (preserved
        // independently of the in-memory wallet state).
        const info = userContext.get_remembered_wallet_info()
        setRememberedInfo(info)
        log("clear_pending_wallet successful, remembered wallet info:", info)
    }
    useEffect(() => {
        onMountedComponent()
    }, []); // equivalent to componentDidMount()

    // Open the remembered wallet: re-load the blob from storage into the
    // pending unlock state, then navigate to the unlock screen.
    async function handleOpenRememberedWallet() {
        const ok = await userContext.prepare_unlock_from_storage()
        if (ok) {
            history.push("/wallet_unlock")
        }
    }

    return (
        <div className="Select_Wallet">
            <div className="mode-selection-style">

                <div className="mode-list">
                    {rememberedInfo ? (
                        <div className={classes.invisibleLink}
                            onClick={handleOpenRememberedWallet}
                            role="button"
                            style={{ cursor: "pointer" }}>
                            <HoverSelector
                                iconClass="fa fa-unlock-alt"
                                title={Constants.OPEN_REMEMBERED_WALLET}
                                description={
                                    (rememberedInfo.walletname
                                        ? "Saved wallet: "+rememberedInfo.walletname
                                        : Constants.OPEN_REMEMBERED_WALLET_INFO)
                                }
                            />
                        </div>
                    ) : null}

                    <NavLink to="/create_new_wallet" className={classes.invisibleLink}>
                        <HoverSelector
                            iconClass="fa fa-plus-square"
                            title={Constants.CREATE_NEW_WALLET}
                            description={Constants.CREATE_WALLET_INFO}
                        />
                    </NavLink>

                    {/*
                    <NavLink to="/new_wallet_from_hardware" className={classes.invisibleLink}> 
                        <HoverSelector
                            iconClass="fa fa-upload"
                            title={"(currently unavailable)"+Constants.CREATE_WALLET_HARDWARE}
                            description={Constants.CREATE_WALLET_HARDWARE_INFO}
                        />
                    </NavLink>
                    */}

                    <NavLink to="/restore_wallet_from_file" className={classes.invisibleLink}>
                        <HoverSelector
                            iconClass="fa fa-folder-open"
                            title={Constants.RESTORE_FROM_FILE}
                            description={Constants.RESTORE_FROM_FILE_INFO}
                        />
                    </NavLink>

                    <NavLink to="/restore_wallet" className={classes.invisibleLink}>
                        <HoverSelector
                            iconClass="fa fa-server"
                            title={Constants.RESTORE_WALLET_SEED}
                            description={Constants.RESTORE_SEED_INFO}
                        />
                    </NavLink>
                </div>

                <div className="return-button">
                    <NavLink className="return-logo" to="/">
                        <ButtonPrimaryOutlined>
                            Back
                        </ButtonPrimaryOutlined>
                    </NavLink>
                </div>

                {/* make it easier to scroll if needed */}
                <div style={{ height: "40vh" }}>&nbsp;</div>

            </div>
        </div>
    );
}
